import Link, {LinkProps} from './Link';

export type {LinkProps};
export default Link;
